import React, { useEffect, useState } from "react";
import { DataTypes } from "../../../../constants";
import { Container, Grid } from "@mui/material";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import FabButton from "../../../Common/Button/FabButton";
import Fetching from "../../../Common/Fetching";
import QualificationForm from "./QualificationFormDialog";
import QualificationCard from "./QualificationCard";

import rmsActions from "../../../../actions/rmsActions";
import {
    getQualifications,
    getRmsAppCode,
    isFetching,
} from "../../../../reducers";
import { connect } from "react-redux";

const QualificationList = ({
    isFetching,
    qualifications,
    getQualifications,
    addQualification,
    updateQualification,
    deleteQualification,
    appCode,
}) => {
    const [openDialog, setOpenDialog] = useState(null);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        getQualifications(appCode);
    }, [getQualifications, appCode]);

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isFetching && (
                    <Grid item md={12}>
                        <Fetching />
                    </Grid>
                )}

                {!!qualifications &&
                    qualifications
                        .sort((a, b) => a.id - b.id)
                        .map((qualification) => (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={6}
                                xl={6}
                                key={qualification.id}
                                className="card-grid-item"
                            >
                                <QualificationCard
                                    qualification={qualification}
                                    onEdit={() => {
                                        setSelected(qualification);
                                        setOpenDialog("update");
                                    }}
                                    onDelete={() => {
                                        setSelected(qualification);
                                        setOpenDialog("delete");
                                    }}
                                />
                            </Grid>
                        ))}

                <FabButton onClick={() => setOpenDialog("add")} />

                {openDialog === "delete" && !!selected && (
                    <ConfirmDialog
                        open
                        title="Delete qualification"
                        content={`The following qualification will be deleted: ${selected.title}`}
                        confirmButtonLabel="Delete"
                        onConfirm={() =>
                            deleteQualification(selected.id, appCode)
                        }
                        onCancel={() => {
                            setOpenDialog(null);
                            setSelected(null);
                        }}
                        onClose={() => {
                            setOpenDialog(null);
                            setSelected(null);
                        }}
                    />
                )}
                {(openDialog === "add" ||
                    (openDialog === "update" && !!selected)) && (
                    <QualificationForm
                        open
                        formTitle={
                            openDialog === "add"
                                ? "New qualification"
                                : "Edit qualification"
                        }
                        data={openDialog === "update" && selected}
                        onSave={
                            openDialog === "add"
                                ? (params) => addQualification(appCode, params)
                                : (params) =>
                                      updateQualification(
                                          selected.id,
                                          params,
                                          appCode
                                      )
                        }
                        onClose={() => {
                            setOpenDialog(null);
                            setSelected(null);
                        }}
                        submitLabel={`${openDialog === "add" ? "Add" : "Save"}`}
                    />
                )}
            </Grid>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    isFetching: isFetching(state, DataTypes.QUALIFICATIONS),
    qualifications: getQualifications(state),
    appCode: getRmsAppCode(state),
});

const mapDispatchToProps = {
    getQualifications: rmsActions.getQualifications,
    addQualification: rmsActions.addQualification,
    updateQualification: rmsActions.updateQualification,
    deleteQualification: rmsActions.deleteQualification,
};

export default connect(mapStateToProps, mapDispatchToProps)(QualificationList);
